import '../../style/index.css';
import './index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/icon/style/css.js
// module id = eR0l
// module chunks = 25